// src/utils/receiverName.js
// 3.66.0 (owner, Oct 23): a receiver name typed in Compose may be saved for
// every client only when it's a company name, never a person ("Attn: Dr.
// Lee", "Mr Smith", "c/o …"). The backend checks the same
// (lib/contacts.js companyName).
const PERSON = /(^|[^a-z])(attn|attention|dr|mr|mrs|ms|miss|mx|c\/o|care of)([^a-z]|$)/i;
export const tidyName = name => String(name || '').replace(/\s+/g, ' ').trim();
export function companyName(name) {
  const n = tidyName(name);
  return n.length >= 2 && n.length <= 60 && /[a-z]/i.test(n) && !PERSON.test(n) && !n.includes(':');
}
